import { j as e } from "./jsx-runtime-e6RZPHeG.js";
import { memo as r } from "react";
const n = ({
  title: l,
  titleId: o,
  ...i
}) => /* @__PURE__ */ e.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": o,
    ...i,
    children: [
      l ? /* @__PURE__ */ e.jsx("title", { id: o, children: l }) : null,
      /* @__PURE__ */ e.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M358.859 829.399a42.614 42.614 0 0 1-30.677-13.035L136.907 618.22c-16.384-16.939-15.893-43.968 1.067-60.331 16.917-16.341 43.968-15.915 60.309 1.067l160.469 166.229 432.277-450.581c16.299-17.003 43.328-17.557 60.331-1.237 17.003 16.299 17.557 43.328 1.259 60.331L389.643 816.279a42.707 42.707 0 0 1-30.72 13.12z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), t = r(n);
export {
  t as default
};
